import React from 'react';
import c from 'classnames';
import PageHeaderMenu from './PageHeaderMenu';

import './style.scss';

interface Props {
  heading: string
  subheading?: string
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6
  children?: React.ReactNode
}

interface PageHeaderComponent extends React.FC<Props> {
  Menu: typeof PageHeaderMenu
}

const PageHeader: PageHeaderComponent = ({
  heading,
  subheading,
  headingLevel = 1,
  children,
}) => {
  const classes = c('PageHeader');

  const HeadingElement = `h${headingLevel}` as const;

  return (
    <div className={classes}>
      <div className="PageHeader__content">

        <HeadingElement className="PageHeader__heading h2">{heading}</HeadingElement>
        {subheading && (
        <span className="PageHeader__subheading">{subheading}</span>
        )}
      </div>
      {children && (
        <div className="PageHeader__children">
          {children}
        </div>
      )}
    </div>
  );
};

PageHeader.Menu = PageHeaderMenu;

export default PageHeader;
